import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Select from "react-select"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import * as Yup from "yup"

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"
import { addPermission, editPermission, getOnePermission, getModules } from "http/UAM/permission.helper"
import { decryptedValue } from "common/utility"


const AddPermission = props => {

  const navigate = useNavigate()

  const location = useLocation();
  const pathnameSegments = location.pathname.split('/');
  const lastSegment = pathnameSegments[pathnameSegments.length - 1];

  //meta title
  document.title = `${lastSegment.toUpperCase()} Permission | FundLync`

  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [selectedMulti, setSelectedMulti] = useState([])
  const [permissionList, setPermissionList] = useState({})
  const [isCreate, setIsCreate] = useState(null)
  const [isEdit, setIsEdit] = useState(null)
  const [isView, setIsView] = useState(null)
  const [isDelete, setIsDelete] = useState(null)
  const [isApprove, setIsApprove] = useState(null)
  const [isReject, setIsReject] = useState(null)
  const [isFullAccess, setIsFullAccess] = useState(null)
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);
  const [assignPermissionList, setAssignPermissionList] = useState([])
  const [moduleOptions, setModuleOptions] = useState([])


  function handleMulti(selectedMulti) {
    setSelectedMulti(selectedMulti)
    setIsCreate(0);
    setIsEdit(0);
    setIsView(0);
    setIsDelete(0);
    setIsApprove(0);
    setIsReject(0);
    setIsFullAccess(0)
    for (let selected of selectedMulti) {
      if (selected.value == "isCreate") {
        setIsCreate(1)
      } else if (selected.value == "isEdit") {
        setIsEdit(1);
      } else if (selected.value == "isView") {
        setIsView(1);
      } else if (selected.value == "isDelete") {
        setIsDelete(1);
      } else if (selected.value == "isApprove") {
        setIsApprove(1);
      } else if (selected.value == "isReject") {
        setIsReject(1);
      } else if (selected.value == "isFullAccess") {
        setIsFullAccess(1);
      }
    }
  }

  const optionGroup = [
    { label: "Is Create", value: "isCreate" },
    { label: "Is Edit", value: "isEdit" },
    { label: "Is View", value: "isView" },
    { label: "Is Delete", value: "isDelete" },
    { label: "Is Approve", value: "isApprove" },
    { label: "Is Reject", value: "isReject" },
    { label: "Is Fullaccess", value: "isFullAccess" },
  ]

  useEffect(() => {
    if (lastSegment == "view" || lastSegment == "edit") {
      getOnePermission({ permissionId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            let responseData = responseFromAPI.data
            setPermissionList(responseData)

            let values = []
            let assignValues = []

            if (responseData.isCreate) {
              values.push({ label: "Is Create", value: "isCreate" })
              assignValues.push("Create")
            }

            if (responseData.isEdit) {
              values.push({ label: "Is Edit", value: "isEdit" });
              assignValues.push("Edit");
            }

            if (responseData.isView) {
              values.push({ label: "Is View", value: "isView" })
              assignValues.push("View")
            }

            if (responseData.isDelete) {
              values.push({ label: "Is Delete", value: "isDelete" })
              assignValues.push("Delete")
            }

            if (responseData.isApprove) {
              values.push({ label: "Is Approve", value: "isApprove" });
              assignValues.push("Approve");
            }

            if (responseData.isReject) {
              values.push({ label: "Is Reject", value: "isReject" });
              assignValues.push("Reject")
            }

            if (responseData.isFullAccess) {
              values.push({ label: "Is Fullaccess", value: "isFullAccess" });
              assignValues.push("Fullaccess")
            }
            setAssignPermissionList(assignValues)
            handleMulti(values)
          }
        })
        .catch(error => { })
    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }

    getModules()
    .then(responseFromAPI => {
      if (responseFromAPI.status && responseFromAPI.code == 200) {
        let modules = responseFromAPI.data.rows.map((ele)=>{
          return {
            value:ele.id,
            label:ele.moduleDisplayName
          }
        })
        setModuleOptions(modules)
      }
    })
    .catch(error => { })
  }, []);

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      permissionName: permissionList.permissionName || "",
      permissionDescription: permissionList.permissionDescription || "",
      assignPermission: (permissionList.isCreate && [permissionList.isCreate]) || [],
      module: (permissionList.moduleId) || "",
      permissionDisplayName: (permissionList.permissionDisplayName) || ''
    },
    validationSchema: Yup.object({
      permissionName: Yup.string().required("Please Enter Permission Name"),
      permissionDescription: Yup.string().required(
        "Please Enter permission Description"
      ),
      assignPermission: Yup.array().required("Please select an option"),
      module: Yup.string().required("Please select an option"),
      permissionDisplayName: Yup.string().required("Please Enter Permission Display Name"),
    }),
    onSubmit: values => {

      const message = lastSegment == 'edit' ? 'Are you sure want to update permission?' : 'Are you sure want to add permission?'
      setShowCommonDialog({ isShow: true, message: message })

    },
  })

  const navigateBack = () => {
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/permission`)
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      upsertPermissions()
      
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const upsertPermissions = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      const updatePermission = {
        id: decodedId,
        permissionName: values.permissionName,
        permissionDescription: values.permissionDescription,
        permissionDisplayName: values.permissionDisplayName,
        moduleId: values["module"],
        isCreate: isCreate,
        isEdit,
        isView,
        isDelete,
        isApprove,
        isReject,
        isFullAccess
      }
      // update permission
      editPermission(updatePermission)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const user = decryptedValue(localStorage.getItem("user"));
            navigate(`/${user.roleName}/permission`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newPermission = {
        moduleId: values["module"],
        permissionName: values["permissionName"],
        permissionDescription: values["permissionDescription"],
        permissionDisplayName: values['permissionDisplayName'],
        isCreate: isCreate,
        isEdit,
        isView,
        isDelete,
        isApprove,
        isReject,
        isFullAccess
      }
      addPermission(newPermission)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const user = decryptedValue(localStorage.getItem("user"));
            navigate(`/${user.roleName}/permission`);
          }
        })
        .catch(error => { })

      validation.resetForm()
      setSelectedMulti([])
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`${lastSegment.toUpperCase()} PERMISSION`} />
          <Row className="vertical-scroll">
            <Col xs="12">
              <div>
                <div>
                  {showEditTemplate && (<Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className="mb-3 d-flex">
                      <Label className="mt-2">Select a Module</Label>
                      <Col xl={4} style={{ marginLeft: "102px" }}>
                        <Input
                          // style={{width:"254%"}}
                          name="module"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.module || ""}
                          invalid={
                            validation.touched.module && validation.errors.module
                          }
                        >
                          <option value="" disabled>
                            Select a Module
                          </option>
                          {moduleOptions.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.module && validation.errors.module ? (
                          <FormFeedback type="invalid">
                            {validation.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>

                    <div className="mb-3 d-flex">
                      <Label className="mt-2">Permission Name</Label>
                      <Col xl={4} style={{ marginLeft: "90px" }}>
                        <Input
                          name="permissionName"
                          type="text"
                          placeholder="Insert Permission Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.permissionName || ""}
                          invalid={
                            validation.touched.permissionName &&
                            validation.errors.permissionName
                          }
                        />
                        {validation.touched.permissionName &&
                          validation.errors.permissionName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.permissionName}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>

                    <div className="mb-3 d-flex">
                      <Label className="mt-2">Permission Display Name</Label>
                      <Col xl={4} style={{ marginLeft: "38px" }}>
                        <Input
                          name="permissionDisplayName"
                          type="text"
                          placeholder="Insert Permission Display Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.permissionDisplayName || ""}
                          invalid={
                            validation.touched.permissionDisplayName &&
                            validation.errors.permissionDisplayName
                          }
                        />
                        {validation.touched.permissionDisplayName &&
                          validation.errors.permissionDisplayName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.permissionDisplayName}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>

                    <div className="mb-3 d-flex">
                      <Label className="mt-2">Permission Description</Label>
                      <Col xl={4} style={{ marginLeft: "54px" }}>
                        <Input
                          name="permissionDescription"
                          type="text"
                          placeholder="Insert Permission Description"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.permissionDescription || ""}
                          invalid={
                            validation.touched.permissionDescription &&
                            validation.errors.permissionDescription
                          }
                        />
                        {validation.touched.permissionDescription &&
                          validation.errors.permissionDescription ? (
                          <FormFeedback type="invalid">
                            {validation.errors.permissionDescription}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>

                    <div className="mb-3 d-flex">
                      <Label className="mt-2">Assign Permission</Label>
                      <Col xl={4} style={{ marginLeft: "84px" }}>
                        <Select
                          name="assignPermission"
                          value={selectedMulti}
                          isMulti={true}
                          onChange={selectedOptions => {
                            handleMulti(selectedOptions)
                          }}
                          options={optionGroup}
                          className={`select2-selection ${!selectedMulti.length ? "is-invalid" : ""
                            }`}
                        />
                        {!selectedMulti.length ? (
                          <FormFeedback type="invalid">
                            {validation.errors.assignPermission}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          <button
                            type="submit"
                            className="btn btn-outline-success"
                            style={{ marginLeft: "7px" }}
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  )}
                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-6 col-form-label label"
                        >
                          Permission Name *
                        </Label>
                        <p className="fs-5">{permissionList.permissionName || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-6 col-form-label label"
                        >
                          Permission Description *
                        </Label>
                        <p className="fs-5">{permissionList.permissionDescription || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-6 col-form-label label"
                        >
                          Assign Permissions
                        </Label>
                        <p className="fs-5">{assignPermissionList.join(",") || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-6 col-form-label label"
                        >
                          Permission Display Name *
                        </Label>
                        <p className="fs-5">{permissionList.permissionDisplayName || "-"}</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div>
                          <button
                            className="btn btn-outline-success"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
    </React.Fragment>
  )
}

AddPermission.propTypes = {
  history: PropTypes.object,
}

export default AddPermission
